import React from "react";
import RosterSubmissions from "../components/roster-submissions/RosterSubmissions";

const RosterSubmissionsContainer = () => {
  return <RosterSubmissions />;
};

export default RosterSubmissionsContainer;
